import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom"
import { RoutePermissions, defaultRoutes, routes } from "../../routes"
import { useSelector } from "react-redux";
import { selectAuth } from "../../features/authSlice";
import { useEffect } from "react";
import { USER_TYPE_BUSINESS_OWNER } from "../../Constant";
import { PAGE_ACCESS_DENIED } from "../../PagesNames";

export const Routing = (): JSX.Element => {
  const user = useSelector(selectAuth);
  const userType = user?.type ?? "";
  const filterRoutes: any[] = userType ? routes.filter(item => RoutePermissions[userType]?.includes(item.name)) : defaultRoutes;

  const navigate = useNavigate();
  useEffect(() => {
    if(user.type === USER_TYPE_BUSINESS_OWNER){
      console.log(navigate(PAGE_ACCESS_DENIED))
      navigate(PAGE_ACCESS_DENIED);
    }
  }, [user.type])
  return (
    <Routes >
      {filterRoutes.map(({ path, element: Component }) => (
        <Route key={path} path={path} element={<Component />} />
      ))}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}
